import React, { useState } from 'react';
import { trackEvent } from '../utils/analytics';
import { useI18n } from '../i18n/I18nContext';

const LeadMagnetBar = () => {
  const { t } = useI18n();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!email.trim()) {
      return;
    }

    trackEvent('lead_magnet_submit', { placement: 'footer_bar', email_domain: email.split('@')[1] || 'unknown' });
    setSubmitted(true);
    setEmail('');
  };

  return (
    <section className="lead-magnet-bar" aria-label="Lead capture">
      <div className="container lead-magnet-content">
        <div>
          <h3>{t('footer.leadTitle')}</h3>
          <p>{t('footer.leadSubtitle')}</p>
        </div>
        <form className="lead-magnet-form" onSubmit={handleSubmit}>
          <label htmlFor="lead-email" className="sr-only">Work email</label>
          <input
            id="lead-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t('footer.leadPlaceholder')}
            required
          />
          <button type="submit" className="btn btn-primary">{t('footer.leadSubmit')}</button>
        </form>
      </div>
      {submitted && (
        <p className="lead-success-message">Thanks! We will share the playbook shortly.</p>
      )}
    </section>
  );
};

export default LeadMagnetBar;
